<template>
    <div class="benefit-list">
        <div class="benefit-container">
            <div class="title-box">V{{ curCardIndex }}等级权益</div>
            <div class="list-box">
                <div
                    v-for="item in benefitList"
                    :key="item.title"
                    class="list-item"
                    @click="onBenefitClick(item)"
                >
                    <div class="icon">
                        <img
                            class="icon-main"
                            :class="{ disabled: !item.unlock }"
                            :src="item.icon"
                            alt=""
                        />
                        <img
                            v-if="item.upgrade"
                            class="icon-up"
                            src="../../../../assets/iconV4.0/icon-up@2x.png"
                            alt=""
                        />
                        <img
                            v-if="!item.unlock"
                            class="icon-lock"
                            src="../../../../assets/iconV4.0/icon-lock@2x.png"
                            alt=""
                        />
                    </div>
                    <div class="title">{{ item.title }}</div>
                    <div class="desc" v-html="item.desc"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';
export default {
    mixins: [homemixin],
    props: {
        curCardIndex: {
            type: Number,
            default: 1
        },
        benefitList: {
            type: Array,
            default: () => []
        },
        benefitInfo: {
            type: Object,
            default: () => {}
        }
    },
    methods: {
        onBenefitClick(data) {
            const { title, desc, redirectUrl, key } = data;
            let allScore = localStorage.getItem('KuserAllScore');
            this.POINT('h5_clk', {
                page: 'super-全部权益页',
                tgt_event_id: 'h5_ACT_allPrivilege',
                tgt_name: 'h5-ACT-全部权益页-权益',
                param: this.benefitInfo.totalScore,
                param1: allScore,
                param2: title,
                param3: this.benefitInfo.currentLevel,
                param4: desc,
                param5: redirectUrl,
                param6: `V${this.curCardIndex}`
            });
            if (redirectUrl) {
                if (key === 'swlb') {
                    this.openLink(
                        `${window.location.protocol}//growthhome.ppdai.com${redirectUrl}`
                    );
                } else {
                    let realUrl = redirectUrl.startsWith('/')
                        ? `${window.location.protocol}//invgrowth.ppdai.com/#${redirectUrl}`
                        : redirectUrl;
                    this.openLink(realUrl);
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.benefit-list {
    width: 375px;
    background: #ffffff;
    border-radius: 16px 16px 0px 0px;
    padding: 26px 18px;
    .title-box {
        height: 18px;
        line-height: 18px;
        font-size: 18px;
        font-weight: 600;
        color: #002a3c;
    }
    .list-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        margin-top: 6px;
        .list-item {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width: 64px;
            height: 75px;
            margin: 18px 10px 0px;
            .icon {
                width: 38px;
                height: 38px;
                position: relative;
                .icon-main {
                    width: 100%;
                    height: 100%;
                    &.disabled {
                        opacity: 0.49;
                    }
                }
                .icon-up {
                    position: absolute;
                    top: -4px;
                    right: -9px;
                    width: 19px;
                    height: 19px;
                }
                .icon-lock {
                    position: absolute;
                    top: -3px;
                    right: -8px;
                    width: 17px;
                    height: 17px;
                }
            }
            .title {
                font-size: 12px;
                font-weight: 400;
                color: #49596c;
                line-height: 14px;
                margin-top: 9px;
            }
            .desc {
                font-size: 12px;
                // font-weight: 600;
                // color: #ff7b29;
                line-height: 14px;
                margin-top: 2px;
            }
        }
    }
}
</style>
